import React, { Fragment } from "react";
import useIsMobile from "../../common/utils/useIsMobile";
import NavigationItem from "./NavigationItem";
import MenuCallToActionButton from "../../common/components/MenuCallToActionButton";
import MobileBackButton from "../../common/components/MobileBackButton";
import useNavigationStack from "../../common/utils/useNavigationStack";
import useEventsBySegment from "../../cms/hooks/useEventsBySegment";
import Loading from "../../common/components/Loading";
import { useLocale } from "next-intl";
import { Link } from "../../../navigation";
import formatDateList from "../../common/utils/formatDateList";

const AcademyNavigationListItem = ({ item, visible, isMobile, rootUrl }) => {
  const locale = useLocale();
  const { meta, children } = item || {};
  const { category } = meta || {};
  const { events, loading } = useEventsBySegment({ segment: category });
  const items = category ? events : children;

  if (loading) return <Loading />;
  return (
    <div className={`row mt-2 ${!visible ? "d-none" : ""}`}>
      {items?.map((child, cIndex) => {
        const image = category ? child?.image : child?.data?.image;
        const subtitle =
          category && child?.date
            ? formatDateList(child?.date, locale)
            : child?.meta?.subtitle;
        const url = category ? child?.slug : child?.url;
        return (
          <div
            key={`${child.title}-${cIndex}`}
            className={` ${isMobile ? "col-6" : `${image ? "col-xl-3 col-lg-4 mb-32px" : "col-lg-12"} `}`}
          >
            <NavigationItem
              link={`${rootUrl}/${url}`}
              title={child.title}
              image={image}
              subtitle={subtitle}
              isLink={true}
              imageSize={{ width: 300, height: 178 }}
            />
          </div>
        );
      })}
    </div>
  );
};

const AcademyLayout = ({ data, backToMainMenu }) => {
  const isMobile = useIsMobile();

  const { back, handleNavigateTo, currentNavigation, callToAction } =
    useNavigationStack(data, backToMainMenu);
  const imageSize = isMobile
    ? { width: 64, height: 64 }
    : { width: 64, height: 64 };
  const normalizedRootUrl = data?.url?.route || data?.url;
  const normalizedCurrentNavigationUrl =
    currentNavigation?.url?.route || currentNavigation?.url;

  return (
    <div className="mkt-sub-nav full-width academy">
      <div className="container container-narrow">
        <MobileBackButton onClick={back} />
        <h3 className="ps-1 hide-on-not-mobile color-secondary regular-sans mt-4 mt-lg-0">
          <Link href={normalizedCurrentNavigationUrl}>
            {currentNavigation?.title}
          </Link>
        </h3>
        <div className="ps-1 row only-show-4-on-mobile">
          {currentNavigation?.children?.map((item, aIndex) => (
            <Fragment key={`${item.title}-${aIndex}`}>
              <div
                className={`col-lg-${aIndex === 0 ? "12" : "0"} navigation-list-column navigation-list-column--academy`}
              >
                <NavigationItem
                  className="navigation-list-item nav-hover d-inline-flex align-items-center gap-3"
                  link={item?.url}
                  title={item.title}
                  image={item.data?.image}
                  imageSize={imageSize}
                  isLink={
                    !isMobile ||
                    (isMobile &&
                      !item?.children?.length &&
                      !item?.meta?.category)
                  }
                  onClick={
                    isMobile
                      ? () => {
                          handleNavigateTo({
                            ...item,
                            children: [
                              ...item?.children,
                              item?.meta?.category,
                            ].filter(Boolean),
                          });
                        }
                      : null
                  }
                />
                <AcademyNavigationListItem
                  item={{ ...currentNavigation, ...item }}
                  isMobile={isMobile}
                  rootUrl={normalizedRootUrl}
                  visible={!isMobile || currentNavigation?.meta?.category}
                  {...item}
                />
              </div>
            </Fragment>
          ))}
        </div>
        <MenuCallToActionButton callToAction={callToAction} />
      </div>
    </div>
  );
};

export default AcademyLayout;
